import * as React from 'react';
import { Button, Heart16, HeartStroke16 } from '@cian/ui-kit';
import { INewbuildingInfo } from '../../../../api/newbuildings';
import { trackNewbuildingFavoriteButtonClick } from './tracking';

export interface IFavoriteButtonStoreProps {
  newbuildingInfo: INewbuildingInfo | null;
}

export interface IFavoriteButtonDispatchProps {
  setFavorite(isFavorite: boolean, newbuildingId: number): void;
}

type TProps = IFavoriteButtonStoreProps & IFavoriteButtonDispatchProps;

export class FavoriteButton extends React.Component<TProps> {
  public render() {
    const { newbuildingInfo } = this.props;

    return (
      newbuildingInfo && (
        <Button
          theme="stroke_secondary"
          size="XS"
          onClick={this.handleToggle}
          beforeIcon={
            newbuildingInfo.isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 color="gray_icons_100" />
          }
        />
      )
    );
  }

  private handleToggle = () => {
    const { newbuildingInfo, setFavorite } = this.props;

    if (newbuildingInfo) {
      const { isFavorite, id } = newbuildingInfo;

      setFavorite(!isFavorite, id);

      trackNewbuildingFavoriteButtonClick(newbuildingInfo, !isFavorite);
    }
  };
}
